import { render, staticRenderFns } from "./yujing.vue?vue&type=template&id=42014848&scoped=true"
import script from "./yujing.vue?vue&type=script&lang=js"
export * from "./yujing.vue?vue&type=script&lang=js"
import style0 from "./yujing.vue?vue&type=style&index=0&id=42014848&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42014848",
  null
  
)

export default component.exports